export default __webpack_public_path__ + "static/media/view4_year_place_.635d2e43.csv";